<template>
    <ModalLayout ref="self" class="CreativeMemory" :collapsed="collapsed" @request-collapse="$emit('request-collapse')">
        <div slot="header" class="header">
            <div class="headerTitle">
                {{ $t('headerTitle') }}
            </div>
        </div>
        <CollapsedContentLayout
            slot="collapsedContent"
            :color="color"
            :title="$t('collapsedTitle')"
            :subtitle="$t('collapsedSubtitle')"
            :button-label="$t('collapsedButtonLabel')"
            @click="$emit('request-expand')"
        />

        <TextBlock slot="content">
            <!-- <h2>Test din kreative hukommelse</h2> -->
            <p>
                Alt som skal til for å huske noe er å bruke fantasien og visualisere det sammen med noe annet. Faktisk,
                jo merkeligere og morsommere du fantaserer, desto lettere og fortere blir det å huske.
            </p>

            <p>
                Husketeknikker bruker nemlig en helt annen del av hjernen til å huske med enn det du kanskje er vant
                til. La oss derfor varme opp hjernen din ved å kikke på noen figurer for tallene 1-10:
            </p>

            <NumbershapeTable />

            <p>
                Vi skal nå bruke disse tallfigurene for å «huske» ti tilfeldige ord i en tilfeldig rekkefølge. Jeg sier
                «huske» med anførselstegn, for alt du trenger å gjøre er å visualisere ti morsomme fantasihistorier på
                hver sin figur - akkurat som om du var regissør i din egen lille tegnefilm. Men, siden dette kanskje er
                første gang, hjelper vi deg også med noen tips til «huskefantasier» du kan bruke.
            </p>
        </TextBlock>
        <div v-if="mustClaimTheory" slot="content" class="claimTheorySection">
            <div class="claimBox">
                <template v-if="justClaimedTheory">
                    <div class="claimBox__text">
                        {{ $t('justClaimed.text') }}
                    </div>
                    <PlainButton class="button" color="#3B7AC0" @click="startTest()">
                        {{ $t('justClaimed.button') }}
                    </PlainButton>
                </template>
                <template v-else>
                    <div class="claimBox__text">
                        {{ $t('claim.text') }}
                    </div>
                    <PlainButton class="button" color="#3B7AC0" @click="claimTheory()">
                        {{ $t('claim.button') }}
                    </PlainButton>
                </template>
            </div>
        </div>
        <div v-else slot="content" class="footer">
            <PlainButton class="button" :color="color" @click="startTest()">
                Start
            </PlainButton>
        </div>
    </ModalLayout>
</template>

<translations>
  collapsedTitle: 'Kreativ hukommelse'
  # Improve your memory with a fun technique.
  collapsedSubtitle: 'Få bedre hukommelse med en morsom teknikk.'
  # collapsedSubtitle: 'Hvor mye husker du nå?'
  collapsedButtonLabel: 'Spill'

  headerTitle: 'Lær en morsom husketeknikk'

  claim:
    text: This was your first mini theory session. Click I have read this to continue.
    text_no: Dette var din første miniøkt med teori. Klikk 'jeg har lest' for å fortsette.
    button: I have read this
    button_no: Jeg har lest dette
  justClaimed:
    text: Congratulation! Let's put this theory into practice now.
    text_no: Gratulerer! La oss praktisere teorien med en gang.
    button: Continue
    button_no: Fortsett
</translations>

<script>
import gameHelper from '@/modules/games-shared/game-helper';
import quizData from '../quiz-data';
import NumbershapeTable from './NumbershapeTable';
import ModalLayout from './ModalLayout';
import TextBlock from './TextBlock';
import PlainButton from './PlainButton';
import CollapsedContentLayout from './CollapsedContentLayout';
import gameTheme from '../game-theme-creative-memory';

export default {
    components: { NumbershapeTable, ModalLayout, TextBlock, PlainButton, CollapsedContentLayout },
    props: {
        collapsed: {
            type: Boolean
        }
    },
    data() {
        return {
            justClaimedTheory: false
        };
    },
    created() {
        this.color = '#CF8426';
        this.mustClaimTheory = !this.$store.state.moduleMemogenius.settings.memoryiqTheory;
    },
    methods: {
        claimTheory() {
            this.justClaimedTheory = true;
            this.$store.dispatch('moduleMemogenius/storeMemoryOnboardingResult', { testName: 'memoryiqTheory' });
        },
        startTest() {
            this.$emit('signal', 'done');
            const items = quizData.map(rawItem => {
                return {
                    number: rawItem.number,
                    image: rawItem.image,
                    name: rawItem.no.name,
                    tip: rawItem.no.tip,
                    tipNumbershape: rawItem.tipNumbershape
                };
            });
            const settings = {
                numberOfItems: items.length,
                itemMemorizeTimeLimit: 1000,
                itemQuizTimeLimit: 10,
                items,

                memorizeSingleCardMode: true,
                quizShowQuestionsSequentially: true,
                quizRandomizeQuestionOrder: true,
                quizShowNumbershapeHints: true,
                quizDropQuestionOnFail: true,
                disableLives: true
            };

            gameHelper.createPracticeSession({
                gameId: 'shopping',
                testName: 'memoryOnboardingTestB',
                theme: gameTheme,
                exitUrl: this.$route.path,
                resultUrl: this.$route.path,
                sessionOptions: settings,
                navigate: true
            });
        },
        getCollapsedHeight() {
            return this.$refs.self.getCollapsedHeight();
        }
    }
};
</script>

<style lang="scss" scoped>
.CreativeMemory {
}
.header {
    padding: 1.5em;
}
.headerTitle {
    font-size: 140%;
    font-weight: bold;
    text-align: center;
}
.NumbershapeTable {
    margin: 2em 0;
}
.footer {
    display: flex;
    justify-content: center;
    padding: 1em;
}
.button {
    padding-left: 3em;
    padding-right: 3em;
}

.claimTheorySection {
    padding: 1em 2em;
}
.claimBox {
    padding: 1em;
    padding-top: 2em;
    background-color: #e0edf8;
    text-align: center;
    border-radius: 0.5em;

    .button {
        display: inline-block;
        margin-top: 1.6em;
    }
}
.claimBox__text {
    font-weight: 600;
    line-height: 1.5em;
    color: rgba(black, 0.7);
    font-size: 110%;
}
</style>
